<template>
	<div>	
		<v-card-title class="d-flex justify-content-between align-center">
			Lista grup
			<v-btn
				color="accent"
				elevation="0"
				class="cursor-pointer"
				@click="showGroupCreateDialog()"
			>
				{{ $vuetify.lang.t('$vuetify.views.groups.buttons.addGroup') }}
			</v-btn>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col cols="8">
					<search v-model="filters.name" @input="searchName" />
				</v-col>
				<v-col>
					<v-select
						v-model="filters.visibility"
						hide-details
						:items="selectOptions"
						outlined
						dense
						class="box-shadow-base font=12"
						:menu-props="{ bottom: true, offsetY: true }"
						:item-text="item => item.text"
						:item-value="item => item.value"
					></v-select>
				</v-col>
			</v-row>
			<div>
				<groups-list
					v-if="groups"
					:data="groups"
					:infinite-scrolling="infiniteScrolling"
				/>
				<div v-if="loading">
					<div v-for="i in 5" :key="i">
						<v-skeleton-loader
							type="text, paragraph"
							class="mt-8"
						></v-skeleton-loader>
					</div>
				</div>
			</div>
		</v-card-text>
		<group-create-dialog ref="group-create-dialog" />
	</div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import Search from "@/components/top-bar/Search";
import GroupCreateDialog from "@/components/groups/GroupCreateDialog";
import GroupsList from "@/components/groups/GroupsList";
export default {
	name: "UserGroups",
	components: {
		Search,
		GroupCreateDialog,
		GroupsList
	},
	data() {
		return {

			delay: 0,
			delayer: null,
			filters: {
				search: '',
				visibility: null
			},
			loading: false,
			selectOptions: [
				{
					value: null,
					text: 'Wszystkie'
				},
				{
					value: 'public',
					text: 'Publiczne'
				},
				{
					value: 'private',
					text: 'Prywatne'
				},
			],
		}
	},
	computed: {
		...mapGetters({
			groups: "groups/groups",
			meta: "groups/meta",
		}),
	},
	watch: {
		'filters.visibility': function(){
			this.searchGroups()
		}
	},
	// created() {
	// 	this.getGroups()
	// },
	methods: {
		...mapActions('groups', [
			'getGroups',
			'clearGroups',
		]),
		async searchName() {
			this.$nextTick(() => {
				console.log()
				this.clearGroups()
				this.searchGroups(1);
			})
			
		
		},
		async searchGroups(page = null) {
			this.loading = true
			await this.getGroups({ params: {
				page: page,
				search: this.filters.search && this.filters.search.length > 1 ? this.fitlers.search : null,
				visibility: this.filters.visibility
			} })
			this.loading = false
		},
		showGroupCreateDialog() {
			this.$refs['group-create-dialog'].showDialog()
		},
		async infiniteScrolling(entries, observer, isIntersecting) {
			if (isIntersecting) {
				if (this.meta.current_page < this.meta.last_page && !this.loading) {
					await this.searchGroups(this.meta.current_page + 1);
				}
			}
		},
	},
	created() {
		this.searchGroups();
	}
}
</script>

<style lang="scss">
.user-group-box {
	box-shadow: 0 2px 2px 0 rgba(58, 57, 76, 0.08) !important;
}
</style>